// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FilterFilledSvg from "@fishx/icons-svg/es/asn/FilterFilled";
import FishxIcon from '../components/FishxIcon';

var FilterFilled = function FilterFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: FilterFilledSvg
  }));
};

FilterFilled.displayName = 'FilterFilled';
export default React.forwardRef(FilterFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/FilterFilled.js
// module id = 2767
// module chunks = 0